import { gql } from '@apollo/client'

/**
 * Combo na visão do produtor. O aluno lê a trilha pela matrícula
 * (getNewPathEnrollment → progressCard.courseProgressCards); o colaborador não
 * tem nenhuma, então a trilha vem direto, com os cursos na ordem do combo. A
 * primeira aula segue o formato da home do preview (lessons), que já resolve
 * sem matrícula.
 */
export const GET_ADMIN_PREVIEW_PATH = gql`
  query getAdminPreviewPath($id: ID!, $offset: Int!, $limit: Int!) {
    adminPreviewPath(id: $id) {
      id
      name
      coursesInOrder(pagination: { offset: $offset, limit: $limit }) {
        id
        imageUrl
        name
        kind
        lessons(pagination: { offset: 0, limit: 1 }) {
          nodes {
            id
            title
            courseContentId
            media {
              id
              type
              originUrl
              providerKey
              fileExt
              hostKey
              host
              organizationUuid
            }
          }
        }
      }
    }
  }
`
